import { computed } from 'mobx';
import ApiModel     from './globals/ApiModel';

export type MountingAttestationCategorySupportThePublicType = 'OP1' | 'OP2' | 'OP3';
export type MountingAttestationCategoryNormalUsageType = 'OS1' | 'OS2' | 'OS3';
export type MountingAttestationGroundHeightType = 'inf_350' | 'sup_350';
export type MountingAttestationHitchType = 'sling' | 'halyard' | 'manual_hoist' | 'motor_hoist' | 'other';
export type MountingAttestationStatus = 'draft' | 'completed';

export default class MountingAttestationModel extends ApiModel {
    static get path() {
        return '/backend/mounting_attestations/{?id}';
    }

    @computed
    get manufacturer(): string {
        return this.get('manufacturer');
    }

    @computed
    get brand(): string {
        return this.get('brand');
    }

    @computed
    get categorySupportThePublic(): MountingAttestationCategorySupportThePublicType {
        return this.get('categorySupportThePublic');
    }

    @computed
    get categoryNormalUsage(): MountingAttestationCategoryNormalUsageType {
        return this.get('categoryNormalUsage');
    }

    @computed
    get groundHeightCategory(): MountingAttestationGroundHeightType {
        return this.get('groundHeightCategory');
    }

    @computed
    get anchoring(): boolean {
        return !!this.get('anchoring');
    }

    @computed
    get assignedTo(): string {
        return this.get('assignedTo');
    }

    @computed
    get guying(): boolean {
        return !!this.get('guying');
    }

    @computed
    get ballasting(): boolean {
        return !!this.get('ballasting');
    }

    @computed
    get selfSupporting(): boolean {
        return !!this.get('selfSupporting');
    }

    @computed
    get windSpeedLimit(): number {
        return this.get('windSpeedLimit');
    }

    @computed
    get summaryDescription(): string {
        return this.get('summaryDescription');
    }

    @computed
    get electricalPowerKva(): number {
        return this.get('electricalPowerKva');
    }

    @computed
    get equipmentDescription(): string {
        return this.get('equipmentDescription');
    }

    @computed
    get suspendedEquipmentSecured(): boolean {
        return !!this.get('suspendedEquipmentSecured');
    }

    @computed
    get weight(): number {
        return this.get('weight');
    }

    @computed
    get hitchType(): MountingAttestationHitchType {
        return this.get('hitchType');
    }

    @computed
    get hitchTypeOther(): MountingAttestationHitchType {
        return this.get('hitchTypeOther');
    }

    @computed
    get installedBy(): string {
        return this.get('installedBy');
    }

    @computed
    get otherDetails(): string {
        return this.get('otherDetails');
    }

    @computed
    get status(): MountingAttestationStatus {
        return this.get('status');
    }
}